import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountInformation } from '../interfaces/account-information.interface';
import { USER_LIST_ENDPOINT } from '../app.constants';

@Injectable()
export class PartnerService {

    constructor(private httpClient: HttpClient) {}

    getAccounts(): Observable<AccountInformation[]> {
        return this.httpClient.get<AccountInformation[]>(`${USER_LIST_ENDPOINT}/partner/accounts`);
    }

}
